import * as React from "react";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import {injectIntl} from "react-intl";
import './index.scss'
import {showDate, getFormattedDate} from "../../../utils";
import __i18n from "../../../intl/__i18n";

function NewUsersChart({data=[], intl}) {
  const {formatMessage} = intl;
  
  return (
    <div className={'chart-wrapper'}>
      <HighchartsReact
        highcharts={Highcharts}
        options={{
          chart: {
            type: 'column'
          },
          title: {
            text: ""
          },
          subtitle: {
            text: ""
          },
          xAxis: {
            type: 'category',
            labels: {
              formatter: function () {
                return getFormattedDate({date : this.value, showTime: false})
              }
            }
          },
          yAxis: {
            min: 0,
            title: {
              text: __i18n("Price in {currency}", {currency: __i18n("Toman")})
            }
          },
          tooltip: {
            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
              '<td style="padding:0"><b>{point.y}</b></td></tr>',
            footerFormat: '</table>',
            shared: true,
            useHTML: true
          },
          plotOptions: {
            column: {
              pointPadding: 0.2,
              borderWidth: 0
            }
          },
          series: [{
            name: formatMessage({
              id: "app.sum_price",
              defaultMessage: "Sum Price"
            }),
            data: data.map(item => [item.created_at, item.price / 10]),
          }]
        }}
      />
    </div>
  )
}

export default injectIntl(NewUsersChart);

